/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreateFederation,
  DashboardFederationAvailable,
  DashboardFederationCountResult,
  DashboardFederationDetail,
  DashboardFederationList,
  DashboardFederationSearchResult,
  DashboardFederationsAttachPlatform,
  DashboardFederationsControllerAttachToPlatform400,
  DashboardFederationsControllerAttachToPlatform401,
  DashboardFederationsControllerAttachToPlatform403,
  DashboardFederationsControllerAttachToPlatform404,
  DashboardFederationsControllerAttachToPlatform429,
  DashboardFederationsControllerAvailableByPublicId400,
  DashboardFederationsControllerAvailableByPublicId401,
  DashboardFederationsControllerAvailableByPublicId404,
  DashboardFederationsControllerAvailableByPublicId429,
  DashboardFederationsControllerAvailableByPublicIdParams,
  DashboardFederationsControllerAvailableCount400,
  DashboardFederationsControllerAvailableCount401,
  DashboardFederationsControllerAvailableCount429,
  DashboardFederationsControllerAvailableSearch400,
  DashboardFederationsControllerAvailableSearch401,
  DashboardFederationsControllerAvailableSearch429,
  DashboardFederationsControllerAvailableSearchParams,
  DashboardFederationsControllerCount400,
  DashboardFederationsControllerCount401,
  DashboardFederationsControllerCount429,
  DashboardFederationsControllerCountParams,
  DashboardFederationsControllerCreate400,
  DashboardFederationsControllerCreate401,
  DashboardFederationsControllerCreate403,
  DashboardFederationsControllerCreate404,
  DashboardFederationsControllerCreate409,
  DashboardFederationsControllerCreate429,
  DashboardFederationsControllerDetachFromPlatform400,
  DashboardFederationsControllerDetachFromPlatform401,
  DashboardFederationsControllerDetachFromPlatform403,
  DashboardFederationsControllerDetachFromPlatform404,
  DashboardFederationsControllerDetachFromPlatform409,
  DashboardFederationsControllerDetachFromPlatform429,
  DashboardFederationsControllerDetail400,
  DashboardFederationsControllerDetail401,
  DashboardFederationsControllerDetail404,
  DashboardFederationsControllerDetail429,
  DashboardFederationsControllerDetailParams,
  DashboardFederationsControllerExport400,
  DashboardFederationsControllerExport401,
  DashboardFederationsControllerExport413,
  DashboardFederationsControllerExport429,
  DashboardFederationsControllerExportParams,
  DashboardFederationsControllerList400,
  DashboardFederationsControllerList401,
  DashboardFederationsControllerList429,
  DashboardFederationsControllerListParams,
  DashboardFederationsControllerMeAvailable400,
  DashboardFederationsControllerMeAvailable401,
  DashboardFederationsControllerMeAvailable429,
  DashboardFederationsControllerMeAvailableParams,
  DashboardFederationsControllerReadableCount400,
  DashboardFederationsControllerReadableCount401,
  DashboardFederationsControllerReadableCount429,
  DashboardFederationsControllerReadableCountParams,
  DashboardFederationsControllerReadableSearch400,
  DashboardFederationsControllerReadableSearch401,
  DashboardFederationsControllerReadableSearch429,
  DashboardFederationsControllerReadableSearchParams,
  DashboardFederationsControllerRefs400,
  DashboardFederationsControllerRefs401,
  DashboardFederationsControllerRefs429,
  DashboardFederationsControllerRefsParams,
  DashboardFederationsControllerUpdate400,
  DashboardFederationsControllerUpdate401,
  DashboardFederationsControllerUpdate403,
  DashboardFederationsControllerUpdate404,
  DashboardFederationsControllerUpdate409,
  DashboardFederationsControllerUpdate429,
  DashboardFederationsDetachPlatform,
  DashboardUpdateFederation,
  FederationRef,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated federation list scoped to the caller. Replaces the legacy `federationList` GraphQL query. Returns slim rows for the dashboard `OrganizationsPage` (general + inline manager contact + platform/sport refs); legal / banking / board / club / document blocks land only on `GET /federations/:id`.

Each row includes `capabilities` — the ORG-directed RBAC capability keys the caller holds on that federation's ORG node (e.g. `ORG:WRITE`) — so the FE can gate per-row actions without follow-up requests.
 * @summary List federations (dashboard)
 */
export const dashboardFederationsControllerList = (
  params?: DashboardFederationsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationList>(
    { url: `/api/dashboard/v1/federations`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerListQueryKey = (
  params?: DashboardFederationsControllerListParams
) => {
  return [`/api/dashboard/v1/federations`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
  TError = ErrorType<
    | DashboardFederationsControllerList400
    | DashboardFederationsControllerList401
    | DashboardFederationsControllerList429
  >,
>(
  params?: DashboardFederationsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardFederationsControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardFederationsControllerList>>> = ({
    signal,
  }) => dashboardFederationsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerList>>
>;
export type DashboardFederationsControllerListQueryError = ErrorType<
  | DashboardFederationsControllerList400
  | DashboardFederationsControllerList401
  | DashboardFederationsControllerList429
>;

export function useDashboardFederationsControllerList<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
  TError = ErrorType<
    | DashboardFederationsControllerList400
    | DashboardFederationsControllerList401
    | DashboardFederationsControllerList429
  >,
>(
  params: undefined | DashboardFederationsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerList<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
  TError = ErrorType<
    | DashboardFederationsControllerList400
    | DashboardFederationsControllerList401
    | DashboardFederationsControllerList429
  >,
>(
  params?: DashboardFederationsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerList<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
  TError = ErrorType<
    | DashboardFederationsControllerList400
    | DashboardFederationsControllerList401
    | DashboardFederationsControllerList429
  >,
>(
  params?: DashboardFederationsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List federations (dashboard)
 */

export function useDashboardFederationsControllerList<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerList>>,
  TError = ErrorType<
    | DashboardFederationsControllerList400
    | DashboardFederationsControllerList401
    | DashboardFederationsControllerList429
  >,
>(
  params?: DashboardFederationsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a federation atomically. Attach an existing main manager via `userId` (a `usr_…` public id) OR quick-create one inline with `managerEmail`/`managerName`/`managerSurname`/`managerPassword?`. Returns the same shape as `GET /federations/:id` so the FE can populate the edit page without a follow-up request.
 * @summary Create federation (dashboard)
 */
export const dashboardFederationsControllerCreate = (
  dashboardCreateFederation: BodyType<DashboardCreateFederation>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationDetail>(
    {
      url: `/api/dashboard/v1/federations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateFederation,
      signal,
    },
    options
  );
};

export const getDashboardFederationsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardFederationsControllerCreate400
    | DashboardFederationsControllerCreate401
    | DashboardFederationsControllerCreate403
    | DashboardFederationsControllerCreate404
    | DashboardFederationsControllerCreate409
    | DashboardFederationsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateFederation> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardFederationsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateFederation> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerCreate>>,
    { data: BodyType<DashboardCreateFederation> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardFederationsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardFederationsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerCreate>>
>;
export type DashboardFederationsControllerCreateMutationBody = BodyType<DashboardCreateFederation>;
export type DashboardFederationsControllerCreateMutationError = ErrorType<
  | DashboardFederationsControllerCreate400
  | DashboardFederationsControllerCreate401
  | DashboardFederationsControllerCreate403
  | DashboardFederationsControllerCreate404
  | DashboardFederationsControllerCreate409
  | DashboardFederationsControllerCreate429
>;

/**
 * @summary Create federation (dashboard)
 */
export const useDashboardFederationsControllerCreate = <
  TError = ErrorType<
    | DashboardFederationsControllerCreate400
    | DashboardFederationsControllerCreate401
    | DashboardFederationsControllerCreate403
    | DashboardFederationsControllerCreate404
    | DashboardFederationsControllerCreate409
    | DashboardFederationsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateFederation> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardFederationsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateFederation> },
  TContext
> => {
  const mutationOptions = getDashboardFederationsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Count of federations matching the same filter shape as `GET /federations`, without fetching rows. Replaces the legacy `federationCount` GraphQL query. Pagination and `orderBy` are ignored.
 * @summary Count federations (dashboard)
 */
export const dashboardFederationsControllerCount = (
  params?: DashboardFederationsControllerCountParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationCountResult>(
    { url: `/api/dashboard/v1/federations/count`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerCountQueryKey = (
  params?: DashboardFederationsControllerCountParams
) => {
  return [`/api/dashboard/v1/federations/count`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerCountQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerCount400
    | DashboardFederationsControllerCount401
    | DashboardFederationsControllerCount429
  >,
>(
  params?: DashboardFederationsControllerCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardFederationsControllerCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardFederationsControllerCount>>> = ({
    signal,
  }) => dashboardFederationsControllerCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerCount>>
>;
export type DashboardFederationsControllerCountQueryError = ErrorType<
  | DashboardFederationsControllerCount400
  | DashboardFederationsControllerCount401
  | DashboardFederationsControllerCount429
>;

export function useDashboardFederationsControllerCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerCount400
    | DashboardFederationsControllerCount401
    | DashboardFederationsControllerCount429
  >,
>(
  params: undefined | DashboardFederationsControllerCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerCount400
    | DashboardFederationsControllerCount401
    | DashboardFederationsControllerCount429
  >,
>(
  params?: DashboardFederationsControllerCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerCount400
    | DashboardFederationsControllerCount401
    | DashboardFederationsControllerCount429
  >,
>(
  params?: DashboardFederationsControllerCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Count federations (dashboard)
 */

export function useDashboardFederationsControllerCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerCount400
    | DashboardFederationsControllerCount401
    | DashboardFederationsControllerCount429
  >,
>(
  params?: DashboardFederationsControllerCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerCountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attach one or more federations (organizations) to a single platform in a single transaction. Additive and idempotent — federations already linked to the target platform are silently skipped. Does NOT touch fees or any other platform association. The caller must have access to the target platform and to every federation id. Returns `204 No Content`; the FE refetches.
 * @summary Attach federations to a platform (dashboard)
 */
export const dashboardFederationsControllerAttachToPlatform = (
  dashboardFederationsAttachPlatform: BodyType<DashboardFederationsAttachPlatform>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/federations/attach-to-platform`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardFederationsAttachPlatform,
      signal,
    },
    options
  );
};

export const getDashboardFederationsControllerAttachToPlatformMutationOptions = <
  TError = ErrorType<
    | DashboardFederationsControllerAttachToPlatform400
    | DashboardFederationsControllerAttachToPlatform401
    | DashboardFederationsControllerAttachToPlatform403
    | DashboardFederationsControllerAttachToPlatform404
    | DashboardFederationsControllerAttachToPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerAttachToPlatform>>,
    TError,
    { data: BodyType<DashboardFederationsAttachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardFederationsControllerAttachToPlatform>>,
  TError,
  { data: BodyType<DashboardFederationsAttachPlatform> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerAttachToPlatform>>,
    { data: BodyType<DashboardFederationsAttachPlatform> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardFederationsControllerAttachToPlatform(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardFederationsControllerAttachToPlatformMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerAttachToPlatform>>
>;
export type DashboardFederationsControllerAttachToPlatformMutationBody =
  BodyType<DashboardFederationsAttachPlatform>;
export type DashboardFederationsControllerAttachToPlatformMutationError = ErrorType<
  | DashboardFederationsControllerAttachToPlatform400
  | DashboardFederationsControllerAttachToPlatform401
  | DashboardFederationsControllerAttachToPlatform403
  | DashboardFederationsControllerAttachToPlatform404
  | DashboardFederationsControllerAttachToPlatform429
>;

/**
 * @summary Attach federations to a platform (dashboard)
 */
export const useDashboardFederationsControllerAttachToPlatform = <
  TError = ErrorType<
    | DashboardFederationsControllerAttachToPlatform400
    | DashboardFederationsControllerAttachToPlatform401
    | DashboardFederationsControllerAttachToPlatform403
    | DashboardFederationsControllerAttachToPlatform404
    | DashboardFederationsControllerAttachToPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerAttachToPlatform>>,
    TError,
    { data: BodyType<DashboardFederationsAttachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardFederationsControllerAttachToPlatform>>,
  TError,
  { data: BodyType<DashboardFederationsAttachPlatform> },
  TContext
> => {
  const mutationOptions = getDashboardFederationsControllerAttachToPlatformMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Detach a single federation from a single platform — the inverse of `attach-to-platform`. Removes the platform association AND its custom-fee rows. Idempotent — a no-op when the federation is not linked to the platform. Blocked with `409 FEDERATION_PLATFORM_OWNER` when the federation owns (or is the data-owner of) the platform, or `409 FEDERATION_LAST_PLATFORM` when the platform is the federation’s only platform. The caller must have access to both. Returns `204 No Content`; the FE refetches.
 * @summary Detach a federation from a platform (dashboard)
 */
export const dashboardFederationsControllerDetachFromPlatform = (
  dashboardFederationsDetachPlatform: BodyType<DashboardFederationsDetachPlatform>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/federations/detach-from-platform`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardFederationsDetachPlatform,
      signal,
    },
    options
  );
};

export const getDashboardFederationsControllerDetachFromPlatformMutationOptions = <
  TError = ErrorType<
    | DashboardFederationsControllerDetachFromPlatform400
    | DashboardFederationsControllerDetachFromPlatform401
    | DashboardFederationsControllerDetachFromPlatform403
    | DashboardFederationsControllerDetachFromPlatform404
    | DashboardFederationsControllerDetachFromPlatform409
    | DashboardFederationsControllerDetachFromPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerDetachFromPlatform>>,
    TError,
    { data: BodyType<DashboardFederationsDetachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardFederationsControllerDetachFromPlatform>>,
  TError,
  { data: BodyType<DashboardFederationsDetachPlatform> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerDetachFromPlatform>>,
    { data: BodyType<DashboardFederationsDetachPlatform> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardFederationsControllerDetachFromPlatform(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardFederationsControllerDetachFromPlatformMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerDetachFromPlatform>>
>;
export type DashboardFederationsControllerDetachFromPlatformMutationBody =
  BodyType<DashboardFederationsDetachPlatform>;
export type DashboardFederationsControllerDetachFromPlatformMutationError = ErrorType<
  | DashboardFederationsControllerDetachFromPlatform400
  | DashboardFederationsControllerDetachFromPlatform401
  | DashboardFederationsControllerDetachFromPlatform403
  | DashboardFederationsControllerDetachFromPlatform404
  | DashboardFederationsControllerDetachFromPlatform409
  | DashboardFederationsControllerDetachFromPlatform429
>;

/**
 * @summary Detach a federation from a platform (dashboard)
 */
export const useDashboardFederationsControllerDetachFromPlatform = <
  TError = ErrorType<
    | DashboardFederationsControllerDetachFromPlatform400
    | DashboardFederationsControllerDetachFromPlatform401
    | DashboardFederationsControllerDetachFromPlatform403
    | DashboardFederationsControllerDetachFromPlatform404
    | DashboardFederationsControllerDetachFromPlatform409
    | DashboardFederationsControllerDetachFromPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerDetachFromPlatform>>,
    TError,
    { data: BodyType<DashboardFederationsDetachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardFederationsControllerDetachFromPlatform>>,
  TError,
  { data: BodyType<DashboardFederationsDetachPlatform> },
  TContext
> => {
  const mutationOptions =
    getDashboardFederationsControllerDetachFromPlatformMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Streamed CSV / XLSX export of the full filtered set with parity against `GET /federations`. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE). Replaces the client-side XLSX builder. Fixed column schema.
 * @summary Export federations (dashboard)
 */
export const dashboardFederationsControllerExport = (
  params: DashboardFederationsControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/federations/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardFederationsControllerExportQueryKey = (
  params: DashboardFederationsControllerExportParams
) => {
  return [`/api/dashboard/v1/federations/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
  TError = ErrorType<
    | DashboardFederationsControllerExport400
    | DashboardFederationsControllerExport401
    | DashboardFederationsControllerExport413
    | DashboardFederationsControllerExport429
  >,
>(
  params: DashboardFederationsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardFederationsControllerExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerExport>>
  > = ({ signal }) => dashboardFederationsControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerExport>>
>;
export type DashboardFederationsControllerExportQueryError = ErrorType<
  | DashboardFederationsControllerExport400
  | DashboardFederationsControllerExport401
  | DashboardFederationsControllerExport413
  | DashboardFederationsControllerExport429
>;

export function useDashboardFederationsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
  TError = ErrorType<
    | DashboardFederationsControllerExport400
    | DashboardFederationsControllerExport401
    | DashboardFederationsControllerExport413
    | DashboardFederationsControllerExport429
  >,
>(
  params: DashboardFederationsControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
  TError = ErrorType<
    | DashboardFederationsControllerExport400
    | DashboardFederationsControllerExport401
    | DashboardFederationsControllerExport413
    | DashboardFederationsControllerExport429
  >,
>(
  params: DashboardFederationsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
  TError = ErrorType<
    | DashboardFederationsControllerExport400
    | DashboardFederationsControllerExport401
    | DashboardFederationsControllerExport413
    | DashboardFederationsControllerExport429
  >,
>(
  params: DashboardFederationsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export federations (dashboard)
 */

export function useDashboardFederationsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
  TError = ErrorType<
    | DashboardFederationsControllerExport400
    | DashboardFederationsControllerExport401
    | DashboardFederationsControllerExport413
    | DashboardFederationsControllerExport429
  >,
>(
  params: DashboardFederationsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated keyword search across federations the caller has RBAC standing on. Default returns slim `FederationRef[]`.

Pass `capabilities=…` to narrow to federations on which the caller holds at least one of the listed RBAC capabilities (union across values). The capability universe is connection-aware: federations exposed to the caller’s capability-holding platforms through ACTIVE platform connections are included — with or without a `platformIds` filter — and `platformIds` may name a connection-admitted TARGET platform (the requested platforms then act as a pure attachment filter; the capability allowlist still ANDs on top). When `capabilities` is absent, the options default to the RBAC membership universe — federations where the caller holds any role assignment or direct capability grant, plus federations linked to such platforms; that membership universe is NOT connection-aware. No-op for admins.

Pass `includeLeagueGrantFederations=true` (LEAGUES list organizations filter only) to additionally offer the organizations owning the leagues the caller holds LEAGUE-node grants on — availability semantics, widening the option list without conferring any org-level read.
 * @summary Federation typeahead search — readable scope (dashboard)
 */
export const dashboardFederationsControllerReadableSearch = (
  params?: DashboardFederationsControllerReadableSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationSearchResult>(
    { url: `/api/dashboard/v1/federations/readable/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerReadableSearchQueryKey = (
  params?: DashboardFederationsControllerReadableSearchParams
) => {
  return [`/api/dashboard/v1/federations/readable/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerReadableSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableSearch400
    | DashboardFederationsControllerReadableSearch401
    | DashboardFederationsControllerReadableSearch429
  >,
>(
  params?: DashboardFederationsControllerReadableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardFederationsControllerReadableSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>
  > = ({ signal }) => dashboardFederationsControllerReadableSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerReadableSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>
>;
export type DashboardFederationsControllerReadableSearchQueryError = ErrorType<
  | DashboardFederationsControllerReadableSearch400
  | DashboardFederationsControllerReadableSearch401
  | DashboardFederationsControllerReadableSearch429
>;

export function useDashboardFederationsControllerReadableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableSearch400
    | DashboardFederationsControllerReadableSearch401
    | DashboardFederationsControllerReadableSearch429
  >,
>(
  params: undefined | DashboardFederationsControllerReadableSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerReadableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableSearch400
    | DashboardFederationsControllerReadableSearch401
    | DashboardFederationsControllerReadableSearch429
  >,
>(
  params?: DashboardFederationsControllerReadableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerReadableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableSearch400
    | DashboardFederationsControllerReadableSearch401
    | DashboardFederationsControllerReadableSearch429
  >,
>(
  params?: DashboardFederationsControllerReadableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Federation typeahead search — readable scope (dashboard)
 */

export function useDashboardFederationsControllerReadableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableSearch400
    | DashboardFederationsControllerReadableSearch401
    | DashboardFederationsControllerReadableSearch429
  >,
>(
  params?: DashboardFederationsControllerReadableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerReadableSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Total federations the caller has RBAC standing on. The FE uses this to decide whether to render the federation filter at all (hide when `total === 0`).

Pass `capabilities=…` to count the SAME universe the `readable/search` picker offers for those keys — the connection-aware, federation-derived RBAC capability universe (RBAC full-org grants ∪ pair grants incl. `viaConnection` ∪ federations linked to capability-held platforms). This keeps filter visibility in sync with the picker: a caller whose federations come via connections or federation-level grants would otherwise see the picker populated but the filter hidden. No-op for admins (unrestricted callers fall back to the full membership count). When absent, the legacy membership count is returned unchanged.
 * @summary Federation count — readable scope (dashboard)
 */
export const dashboardFederationsControllerReadableCount = (
  params?: DashboardFederationsControllerReadableCountParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationCountResult>(
    { url: `/api/dashboard/v1/federations/readable/count`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerReadableCountQueryKey = (
  params?: DashboardFederationsControllerReadableCountParams
) => {
  return [`/api/dashboard/v1/federations/readable/count`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerReadableCountQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableCount400
    | DashboardFederationsControllerReadableCount401
    | DashboardFederationsControllerReadableCount429
  >,
>(
  params?: DashboardFederationsControllerReadableCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardFederationsControllerReadableCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>
  > = ({ signal }) => dashboardFederationsControllerReadableCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerReadableCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>
>;
export type DashboardFederationsControllerReadableCountQueryError = ErrorType<
  | DashboardFederationsControllerReadableCount400
  | DashboardFederationsControllerReadableCount401
  | DashboardFederationsControllerReadableCount429
>;

export function useDashboardFederationsControllerReadableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableCount400
    | DashboardFederationsControllerReadableCount401
    | DashboardFederationsControllerReadableCount429
  >,
>(
  params: undefined | DashboardFederationsControllerReadableCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerReadableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableCount400
    | DashboardFederationsControllerReadableCount401
    | DashboardFederationsControllerReadableCount429
  >,
>(
  params?: DashboardFederationsControllerReadableCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerReadableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableCount400
    | DashboardFederationsControllerReadableCount401
    | DashboardFederationsControllerReadableCount429
  >,
>(
  params?: DashboardFederationsControllerReadableCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Federation count — readable scope (dashboard)
 */

export function useDashboardFederationsControllerReadableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerReadableCount400
    | DashboardFederationsControllerReadableCount401
    | DashboardFederationsControllerReadableCount429
  >,
>(
  params?: DashboardFederationsControllerReadableCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerReadableCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerReadableCountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated keyword search across federations the caller has any relation with. Returns slim `FederationRef[]` (`id`, `organizationName`, `organizationAbbreviation`, `logo`) — no rich variant.

The rich available shape lives at `GET /federations/me/available` as a single-record cold-start endpoint; the available picker only needs labels.
 * @summary Federation typeahead search — available scope (dashboard)
 */
export const dashboardFederationsControllerAvailableSearch = (
  params?: DashboardFederationsControllerAvailableSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationSearchResult>(
    { url: `/api/dashboard/v1/federations/available/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerAvailableSearchQueryKey = (
  params?: DashboardFederationsControllerAvailableSearchParams
) => {
  return [`/api/dashboard/v1/federations/available/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerAvailableSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableSearch400
    | DashboardFederationsControllerAvailableSearch401
    | DashboardFederationsControllerAvailableSearch429
  >,
>(
  params?: DashboardFederationsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardFederationsControllerAvailableSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>
  > = ({ signal }) => dashboardFederationsControllerAvailableSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerAvailableSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>
>;
export type DashboardFederationsControllerAvailableSearchQueryError = ErrorType<
  | DashboardFederationsControllerAvailableSearch400
  | DashboardFederationsControllerAvailableSearch401
  | DashboardFederationsControllerAvailableSearch429
>;

export function useDashboardFederationsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableSearch400
    | DashboardFederationsControllerAvailableSearch401
    | DashboardFederationsControllerAvailableSearch429
  >,
>(
  params: undefined | DashboardFederationsControllerAvailableSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableSearch400
    | DashboardFederationsControllerAvailableSearch401
    | DashboardFederationsControllerAvailableSearch429
  >,
>(
  params?: DashboardFederationsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableSearch400
    | DashboardFederationsControllerAvailableSearch401
    | DashboardFederationsControllerAvailableSearch429
  >,
>(
  params?: DashboardFederationsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Federation typeahead search — available scope (dashboard)
 */

export function useDashboardFederationsControllerAvailableSearch<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableSearch400
    | DashboardFederationsControllerAvailableSearch401
    | DashboardFederationsControllerAvailableSearch429
  >,
>(
  params?: DashboardFederationsControllerAvailableSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerAvailableSearchQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Total federations the caller has any relation with. The FE uses this to decide whether to render the federation filter at all (hide when `total === 0`).
 * @summary Federation count — available scope (dashboard)
 */
export const dashboardFederationsControllerAvailableCount = (
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationCountResult>(
    { url: `/api/dashboard/v1/federations/available/count`, method: "GET", signal },
    options
  );
};

export const getDashboardFederationsControllerAvailableCountQueryKey = () => {
  return [`/api/dashboard/v1/federations/available/count`] as const;
};

export const getDashboardFederationsControllerAvailableCountQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableCount400
    | DashboardFederationsControllerAvailableCount401
    | DashboardFederationsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardFederationsControllerAvailableCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>
  > = ({ signal }) => dashboardFederationsControllerAvailableCount(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerAvailableCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>
>;
export type DashboardFederationsControllerAvailableCountQueryError = ErrorType<
  | DashboardFederationsControllerAvailableCount400
  | DashboardFederationsControllerAvailableCount401
  | DashboardFederationsControllerAvailableCount429
>;

export function useDashboardFederationsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableCount400
    | DashboardFederationsControllerAvailableCount401
    | DashboardFederationsControllerAvailableCount429
  >,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableCount400
    | DashboardFederationsControllerAvailableCount401
    | DashboardFederationsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableCount400
    | DashboardFederationsControllerAvailableCount401
    | DashboardFederationsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Federation count — available scope (dashboard)
 */

export function useDashboardFederationsControllerAvailableCount<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableCount400
    | DashboardFederationsControllerAvailableCount401
    | DashboardFederationsControllerAvailableCount429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardFederationsControllerAvailableCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerAvailableCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the **available** Federation projection for the caller's first available row — the cold-start source for `CurrentOrganizationContext`. Use this when the user is in normal (non-admin) mode and just needs the org shell (name, logo, country, mainManager).

Pass `platformId` to scope the pick to the current platform. Without it, a caller with federations across several platforms gets their first available federation from *any* platform — the wrong org for multi-platform users. The id is intersected with the caller's available platform set; an unknown or inaccessible id yields `204`.

Response shape: `DashboardFederationAvailable` — intentionally narrow. Contact info, lifecycle status, and other admin-only fields are not exposed here; they live on `GET /federations/:id`.

Includes `capabilities` — the RBAC capability keys the caller holds on the federation — so the FE can gate org-scoped controls (create users / teams / clubs, …) without a follow-up request. When `platformId` is passed, the set is pair-scoped to the `(platform, federation)` pair (grants held at other platforms do not surface); otherwise it is the platform-agnostic ORG-node aggregate. `platformIds` carries the numeric ids of the platforms the federation is attached to, for FE-side pair validation.

**FE contract: branch on HTTP status, not on the body.** `200` carries the available projection; `204 No Content` means the caller has zero available federations.
 * @summary Caller's default available federation (cold-start bootstrap)
 */
export const dashboardFederationsControllerMeAvailable = (
  params?: DashboardFederationsControllerMeAvailableParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationAvailable | void>(
    { url: `/api/dashboard/v1/federations/me/available`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerMeAvailableQueryKey = (
  params?: DashboardFederationsControllerMeAvailableParams
) => {
  return [`/api/dashboard/v1/federations/me/available`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerMeAvailableQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardFederationsControllerMeAvailable400
    | DashboardFederationsControllerMeAvailable401
    | DashboardFederationsControllerMeAvailable429
  >,
>(
  params?: DashboardFederationsControllerMeAvailableParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardFederationsControllerMeAvailableQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>
  > = ({ signal }) => dashboardFederationsControllerMeAvailable(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerMeAvailableQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>
>;
export type DashboardFederationsControllerMeAvailableQueryError = ErrorType<
  | DashboardFederationsControllerMeAvailable400
  | DashboardFederationsControllerMeAvailable401
  | DashboardFederationsControllerMeAvailable429
>;

export function useDashboardFederationsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardFederationsControllerMeAvailable400
    | DashboardFederationsControllerMeAvailable401
    | DashboardFederationsControllerMeAvailable429
  >,
>(
  params: undefined | DashboardFederationsControllerMeAvailableParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardFederationsControllerMeAvailable400
    | DashboardFederationsControllerMeAvailable401
    | DashboardFederationsControllerMeAvailable429
  >,
>(
  params?: DashboardFederationsControllerMeAvailableParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardFederationsControllerMeAvailable400
    | DashboardFederationsControllerMeAvailable401
    | DashboardFederationsControllerMeAvailable429
  >,
>(
  params?: DashboardFederationsControllerMeAvailableParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Caller's default available federation (cold-start bootstrap)
 */

export function useDashboardFederationsControllerMeAvailable<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
  TError = ErrorType<
    | DashboardFederationsControllerMeAvailable400
    | DashboardFederationsControllerMeAvailable401
    | DashboardFederationsControllerMeAvailable429
  >,
>(
  params?: DashboardFederationsControllerMeAvailableParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerMeAvailable>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerMeAvailableQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the **available** Federation projection for the requested public id. Replaces the legacy GraphQL `availableFederationById` query — same audience, same shape (`DashboardFederationAvailable`).

The federation is resolved from its public id (`fed_…`) and then checked against the caller's available set on the server. Ids outside that set return `404 NOT_FOUND` rather than 403 — the slim row's existence isn't sensitive, but the rich projection is per-caller.

Includes `capabilities` — the RBAC capability keys the caller holds on the federation — so the FE can gate org-scoped controls (create users / teams / clubs, …) without a follow-up request. Pass the optional `platformId` query param (`plt_…`, the current platform) to pair-scope that set to the `(platform, federation)` pair: grants held at other platforms then do not surface. Without it (or with an unknown id) the set is the platform-agnostic ORG-node aggregate.

Also includes `platformPublicIds` — the public ids (`plt_…`) of the platforms the federation is attached to — so the FE can reject a scoped URL whose platform/organization pair is not a real attachment.
 * @summary Federation by public id — available scope (dashboard)
 */
export const dashboardFederationsControllerAvailableByPublicId = (
  id: string,
  params?: DashboardFederationsControllerAvailableByPublicIdParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationAvailable>(
    { url: `/api/dashboard/v1/federations/available/${id}`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerAvailableByPublicIdQueryKey = (
  id: string,
  params?: DashboardFederationsControllerAvailableByPublicIdParams
) => {
  return [`/api/dashboard/v1/federations/available/${id}`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerAvailableByPublicIdQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableByPublicId400
    | DashboardFederationsControllerAvailableByPublicId401
    | DashboardFederationsControllerAvailableByPublicId404
    | DashboardFederationsControllerAvailableByPublicId429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerAvailableByPublicIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDashboardFederationsControllerAvailableByPublicIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>
  > = ({ signal }) =>
    dashboardFederationsControllerAvailableByPublicId(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerAvailableByPublicIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>
>;
export type DashboardFederationsControllerAvailableByPublicIdQueryError = ErrorType<
  | DashboardFederationsControllerAvailableByPublicId400
  | DashboardFederationsControllerAvailableByPublicId401
  | DashboardFederationsControllerAvailableByPublicId404
  | DashboardFederationsControllerAvailableByPublicId429
>;

export function useDashboardFederationsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableByPublicId400
    | DashboardFederationsControllerAvailableByPublicId401
    | DashboardFederationsControllerAvailableByPublicId404
    | DashboardFederationsControllerAvailableByPublicId429
  >,
>(
  id: string,
  params: undefined | DashboardFederationsControllerAvailableByPublicIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableByPublicId400
    | DashboardFederationsControllerAvailableByPublicId401
    | DashboardFederationsControllerAvailableByPublicId404
    | DashboardFederationsControllerAvailableByPublicId429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerAvailableByPublicIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableByPublicId400
    | DashboardFederationsControllerAvailableByPublicId401
    | DashboardFederationsControllerAvailableByPublicId404
    | DashboardFederationsControllerAvailableByPublicId429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerAvailableByPublicIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Federation by public id — available scope (dashboard)
 */

export function useDashboardFederationsControllerAvailableByPublicId<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
  TError = ErrorType<
    | DashboardFederationsControllerAvailableByPublicId400
    | DashboardFederationsControllerAvailableByPublicId401
    | DashboardFederationsControllerAvailableByPublicId404
    | DashboardFederationsControllerAvailableByPublicId429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerAvailableByPublicIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerAvailableByPublicId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerAvailableByPublicIdQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Batched id → ref lookup for filter-chip rehydration. Returns slim, public-safe identity fields (`id`, `organizationName`, `organizationAbbreviation`, `logo`). Not scope-restricted — chips need to render labels for ids the caller may have saved before a scope change. Missing ids are simply absent from the response.
 * @summary Resolve federation refs by id (dashboard)
 */
export const dashboardFederationsControllerRefs = (
  params: DashboardFederationsControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<FederationRef[]>(
    { url: `/api/dashboard/v1/federations/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerRefsQueryKey = (
  params: DashboardFederationsControllerRefsParams
) => {
  return [`/api/dashboard/v1/federations/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
  TError = ErrorType<
    | DashboardFederationsControllerRefs400
    | DashboardFederationsControllerRefs401
    | DashboardFederationsControllerRefs429
  >,
>(
  params: DashboardFederationsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardFederationsControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>> = ({
    signal,
  }) => dashboardFederationsControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>
>;
export type DashboardFederationsControllerRefsQueryError = ErrorType<
  | DashboardFederationsControllerRefs400
  | DashboardFederationsControllerRefs401
  | DashboardFederationsControllerRefs429
>;

export function useDashboardFederationsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
  TError = ErrorType<
    | DashboardFederationsControllerRefs400
    | DashboardFederationsControllerRefs401
    | DashboardFederationsControllerRefs429
  >,
>(
  params: DashboardFederationsControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
  TError = ErrorType<
    | DashboardFederationsControllerRefs400
    | DashboardFederationsControllerRefs401
    | DashboardFederationsControllerRefs429
  >,
>(
  params: DashboardFederationsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
  TError = ErrorType<
    | DashboardFederationsControllerRefs400
    | DashboardFederationsControllerRefs401
    | DashboardFederationsControllerRefs429
  >,
>(
  params: DashboardFederationsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve federation refs by id (dashboard)
 */

export function useDashboardFederationsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>,
  TError = ErrorType<
    | DashboardFederationsControllerRefs400
    | DashboardFederationsControllerRefs401
    | DashboardFederationsControllerRefs429
  >,
>(
  params: DashboardFederationsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardFederationsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update. Send only the fields a given wizard tab owns; absent keys are left untouched, explicit `null` clears nullable columns. `managers` / `boardMembers` / `clubMembers` are full set-replaces (send `[]` to clear). `customFees` is a platform-keyed map (`{ [plt_id]: fees[] | null }`): each present key full-replaces that platform's fees (entry + license rows, by `serviceType`), `null` clears them, and platforms absent from the map are untouched. Referencing an inaccessible or not-operated-on platform → `403 PLATFORM_FORBIDDEN`; an unknown `plt_` id → `404`. Switching `legalEntityType` resets `bankEnabled` to false. Returns the same shape as `GET /federations/:id` so every tab can reset from the response.
 * @summary Update federation (dashboard)
 */
export const dashboardFederationsControllerUpdate = (
  id: string,
  dashboardUpdateFederation: BodyType<DashboardUpdateFederation>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardFederationDetail>(
    {
      url: `/api/dashboard/v1/federations/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateFederation,
    },
    options
  );
};

export const getDashboardFederationsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardFederationsControllerUpdate400
    | DashboardFederationsControllerUpdate401
    | DashboardFederationsControllerUpdate403
    | DashboardFederationsControllerUpdate404
    | DashboardFederationsControllerUpdate409
    | DashboardFederationsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateFederation> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardFederationsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateFederation> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdateFederation> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardFederationsControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardFederationsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerUpdate>>
>;
export type DashboardFederationsControllerUpdateMutationBody = BodyType<DashboardUpdateFederation>;
export type DashboardFederationsControllerUpdateMutationError = ErrorType<
  | DashboardFederationsControllerUpdate400
  | DashboardFederationsControllerUpdate401
  | DashboardFederationsControllerUpdate403
  | DashboardFederationsControllerUpdate404
  | DashboardFederationsControllerUpdate409
  | DashboardFederationsControllerUpdate429
>;

/**
 * @summary Update federation (dashboard)
 */
export const useDashboardFederationsControllerUpdate = <
  TError = ErrorType<
    | DashboardFederationsControllerUpdate400
    | DashboardFederationsControllerUpdate401
    | DashboardFederationsControllerUpdate403
    | DashboardFederationsControllerUpdate404
    | DashboardFederationsControllerUpdate409
    | DashboardFederationsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateFederation> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardFederationsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateFederation> },
  TContext
> => {
  const mutationOptions = getDashboardFederationsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Full federation detail for the dashboard edit page — every section the wizard tabs reset from (general / managers / legal / banking / board / club / documents / sports). Replaces the legacy `findOrganization` + `federationWithManagers` GraphQL queries. 404 when the federation does not exist or is outside the caller's scope.

A federation's sports are stored per platform; pass `platformId` (a `plt_…` public id) to seed the edit form's sport selector from that one platform. Omit it to receive the deduped union across every platform the federation is bound to.

The managers section is capability-dependent: `mainManager` / `managers` are only populated for callers holding `ORG_MANAGER:READ` on the federation (the management-team gate); everyone else gets `null` / `[]` while the rest of the detail stays readable.
 * @summary Get federation detail (dashboard)
 */
export const dashboardFederationsControllerDetail = (
  id: string,
  params?: DashboardFederationsControllerDetailParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardFederationDetail>(
    { url: `/api/dashboard/v1/federations/${id}`, method: "GET", params, signal },
    options
  );
};

export const getDashboardFederationsControllerDetailQueryKey = (
  id: string,
  params?: DashboardFederationsControllerDetailParams
) => {
  return [`/api/dashboard/v1/federations/${id}`, ...(params ? [params] : [])] as const;
};

export const getDashboardFederationsControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
  TError = ErrorType<
    | DashboardFederationsControllerDetail400
    | DashboardFederationsControllerDetail401
    | DashboardFederationsControllerDetail404
    | DashboardFederationsControllerDetail429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardFederationsControllerDetailQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>
  > = ({ signal }) => dashboardFederationsControllerDetail(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardFederationsControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>
>;
export type DashboardFederationsControllerDetailQueryError = ErrorType<
  | DashboardFederationsControllerDetail400
  | DashboardFederationsControllerDetail401
  | DashboardFederationsControllerDetail404
  | DashboardFederationsControllerDetail429
>;

export function useDashboardFederationsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
  TError = ErrorType<
    | DashboardFederationsControllerDetail400
    | DashboardFederationsControllerDetail401
    | DashboardFederationsControllerDetail404
    | DashboardFederationsControllerDetail429
  >,
>(
  id: string,
  params: undefined | DashboardFederationsControllerDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
  TError = ErrorType<
    | DashboardFederationsControllerDetail400
    | DashboardFederationsControllerDetail401
    | DashboardFederationsControllerDetail404
    | DashboardFederationsControllerDetail429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardFederationsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
  TError = ErrorType<
    | DashboardFederationsControllerDetail400
    | DashboardFederationsControllerDetail401
    | DashboardFederationsControllerDetail404
    | DashboardFederationsControllerDetail429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get federation detail (dashboard)
 */

export function useDashboardFederationsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
  TError = ErrorType<
    | DashboardFederationsControllerDetail400
    | DashboardFederationsControllerDetail401
    | DashboardFederationsControllerDetail404
    | DashboardFederationsControllerDetail429
  >,
>(
  id: string,
  params?: DashboardFederationsControllerDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardFederationsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardFederationsControllerDetailQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
